import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Spinner } from "../../components/Layout";

const FormSpinner = (props) => {
  const { startSpinner, handleCloseSpinner } = props;
  return (
    <Dialog
      id="avis-form-spinner-dialog"
      open={startSpinner}
      onClose={handleCloseSpinner}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth
      disableEscapeKeyDown="true"
    >
      <DialogTitle id="alert-dialog-title"></DialogTitle>
      <DialogContent id="avis-form-spinner-content">
        <div id="avis-form-spinner-div" className=" flex w-full justify-center items-center">
          <Spinner
            accessibilityLabel="Loading"
            className="uxf-spinner-border-lg"
            animation="border"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FormSpinner;
